import * as React from 'react';
const SvgRadioOnPhone = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none" }, props),
    React.createElement("circle", { cx: 11, cy: 11, r: 10, stroke: "#6e00a5" }),
    React.createElement("circle", { cx: 11, cy: 11, r: 5, fill: "#6e00a5" })));
export default SvgRadioOnPhone;
